module.exports = __webpack_public_path__ + "img/MA.6adbfdf3.png";